import { forkJoin as observableForkJoin, Observable } from "rxjs";
import { Address } from "../../../shared/models/adress.model";
import { Association } from "../../../shared/models/association.model";
import { ICountry } from "../../../shared/models/country.interface";
import { AssociationService } from "../../../shared/services/association.service";
import { CountryService } from "../../../shared/services/country.service";
import { Component, OnInit, TemplateRef } from "@angular/core";
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
} from "@angular/forms";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { ToastyService } from "ng2-toasty";
import {
  BsModalService,
  BsModalRef,
  BsLocaleService,
  defineLocale,
} from "ngx-bootstrap";
import * as moment from "moment";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ImageCropperComponent } from "./image-cropper/image-cropper.component";
import { AssocType } from "../../../shared/models/assoc-type.interface";
import { SlugifyPipe } from "../../../shared/pipes/slugify.pipe";
import { Odd } from "app/shared/models/odd.interface";
import { Region } from "app/shared/models/region.interface";

@Component({
  selector: "app-associations-details",
  templateUrl: "./associations-details.component.html",
  styleUrls: ["./associations-details.component.css"],
})
export class AssociationsDetailsComponent implements OnInit {
  public association: Association = new Association();
  public associationDetailsForm: FormGroup;
  public logo: File = null;
  public banner: File = null;
  public description: File = null;
  public signature: File = null;
  public event: File = null;

  public assocTypesSelected: AssocType;
  public assocTypesPrivate: AssocType[] = [];
  private assocTypes: AssocType[];
  public odds: Odd[];
  public regions: Region[];

  public enterprise_cerfa_cases = [
    { value: 1, name: 'Œuvre ou organisme d’intérêt général: Association loi 1901' },
    { value: 2, name: 'Œuvre ou organisme d’intérêt général: Association ou fondation reconnue d’utilité publique' },
    { value: 3, name: 'Œuvre ou organisme d’intérêt général: Fondation universitaire ou fondation partenariale' },
    { value: 4, name: 'Œuvre ou organisme d’intérêt général: Fondation d’entreprise' },
    { value: 5, name: 'Œuvre ou organisme d’intérêt général: Musée de France' },
    {
      value: 6,
      name: 'Œuvre ou organisme d’intérêt général: Organismes sans but lucratif fournissant gratuitement une aide alimentaire/soins médicaux/des produits de première nécessité'
    },
    { value: 7, name: 'Œuvre ou organisme d’intérêt général: Autre' },
    { value: 8, name: 'Association cultuelle ou établissement public des cultes reconnus d’Alsace-Moselle' },
    { value: 9, name: 'Établissement d’enseignement supérieur ou d’enseignement artistique public ou privé, d’intérêt général, à but non lucratif' },
    { value: 10, name: 'Établissement d’enseignement supérieur consulaire mentionné à l\'article L. 711-17 du code de commerce' },
    { value: 11, name: 'Société ou organisme public ou privé agréé par le ministre chargé du budget' },
    { value: 12, name: 'Organisme public ou privé dont la gestion est désintéressée et qui a pour activité principale la présentation au public d\'œuvres audiovisuelles' },
    { value: 13, name: 'Projet de thèse proposé au mécénat de doctorat par une école doctorale' },
    { value: 14, name: 'Société, dont l’État est l\'actionnaire unique, qui a pour activité la représentation de la France aux expositions universelles' },
    { value: 15, name: 'Société nationale de programme mentionnée à l’article 44 de la loi n° 86-1067 du 30 septembre 1986' },
    { value: 16, name: 'Société nationale de programme mentionnée au III de l\'article 44 de la loi n° 86-1067 du 30 septembre 1986' },
    { value: 17, name: 'Fondation du patrimoine ou fondation ou association reconnue d’utilité publique qui subventionnent des travaux sur des monuments historiques' },
    { value: 18, name: 'Fonds de dotation' },
    { value: 19, name: 'Organisme agréé ayant pour objet exclusif d’accorder des aides financières/fournir des prestations d’accompagnement à des petites/moyennes entreprises' },
    { value: 20, name: 'Fédération ou union d’organismes ayant pour objet exclusif de fédérer, d’organiser, de représenter et de promouvoir les organismes agréés' },
    { value: 21, name: 'Organismes ayant pour objet la sauvegarde, contre les effets d’un conflit armé, des biens culturels' },
    { value: 22, name: 'Organisme établi dans un État membre de l’Union européenne autre que la France' },
  ];
  public individual_cerfa_cases = [
    { value: 1, name: 'Œuvre ou organisme d’intérêt général: Association loi 1901' },
    { value: 2, name: 'Œuvre ou organisme d’intérêt général: Association ou fondation reconnue d’utilité publique' },
    { value: 3, name: 'Œuvre ou organisme d’intérêt général: Fondation universitaire ou fondation partenariale' },
    { value: 4, name: 'Œuvre ou organisme d’intérêt général: Fondation d’entreprise' },
    { value: 5, name: 'Œuvre ou organisme d’intérêt général: Musée de France' },
    {
      value: 6,
      name: 'Œuvre ou organisme d’intérêt général: Organismes sans but lucratif fournissant gratuitement une aide alimentaire/soins médicaux/des produits de première nécessité'
    },
    { value: 7, name: 'Œuvre ou organisme d’intérêt général: Communes, syndicats intercommunaux ou mixtes de gestion forestière, groupements syndicaux forestiers' },
    { value: 8, name: 'Œuvre ou organisme d’intérêt général: Autre' },
    { value: 9, name: 'Association cultuelle et établissement public reconnus d’Alsace-Moselle' },
    { value: 10, name: 'Fonds de dotation' },
    { value: 11, name: 'Association d\'intérêt général exerçant des actions concrètes en faveur du pluralisme de la presse' },
    { value: 12, name: 'Etablissement d’enseignement supérieur ou d’enseignement artistique public ou privé, d’intérêt général, à but non lucratif' },
    { value: 13, name: 'Etablissement d’enseignement supérieur consulaire mentionné à l\'article L. 711-17 du code de commerce' },
    { value: 14, name: 'Organisme agréé ayant pour objectif exclusif d\'accorder des aides financières ou de fournir des prestations d\'accompagnement' },
    { value: 15, name: 'Organisme public ou privé dont la gestion est désintéressée et qui a pour activité principale la présentation au public d\'œuvres audiovisuelles' },
    { value: 16, name: 'Fondation du patrimoine ou fondation ou association reconnue d’utilité publique qui subventionnent des travaux sur des monuments historiques' },
    { value: 17, name: 'Organisme ayant pour objet la sauvegarde, contre les effets d\'un conflit armé, de biens culturels' },
    { value: 18, name: 'Etablissement de recherche public ou privé, d’intérêt général, à but non lucratif' },
    { value: 19, name: 'Entreprise d’insertion ou entreprise de travail temporaire d’insertion' },
    { value: 20, name: 'Association intermédiaire' },
    { value: 21, name: 'Ateliers et chantiers d’insertion' },
    { value: 22, name: 'Entreprise adaptéees' },
    { value: 23, name: 'Agence nationale de la recherche (ANR)' },
    { value: 24, name: 'Groupement d\'employeurs pour l\'insertion et la qualification' },
    { value: 25, name: 'Association reconnue d\'utilité publique de financement et d\'accompagnement de la création et de la reprise d\'entreprises' },
    { value: 26, name: 'Organisme établi dans un Etat membre de l’Union européenne autre que la France'}
  ];
  public cerfa_article = [
    { value: 1, name: '200 du CGI' },
    { value: 2, name: '978 du CGI' }
  ];


  public assocTypesCerfa = [
    {
      value: "GENERATED",
      name: "Généré",
    },
    {
      value: "ASSOC_HANDLED",
      name: "Envoyé par l'association",
    },
  ];
  public assocCertification = [
    {
      value: "DON_EN_CONFIANCE",
      name: "Don en confiance",
    },
    {
      value: "EPIC_FONDATION",
      name: "Epic Fondation",
    },
    {
      value: "GANDEE",
      name: "Gandee",
    },
    {
      value: "IDEAS",
      name: "Ideas",
    },
    {
      value: "DO_GOOD",
      name: "DO GOOD",
    },
  ];
  public assocStatus = [
    {
      value: "PUBLIC_UTILITY",
      name: "Utilité publique",
    },
    {
      value: "GENERAL_INTEREST",
      name: "Intérêt géneral",
    },
  ];

  countries: ICountry[] = [];
  nationalities: any[] = [];
  categories: any[];
  confirmModalRef: BsModalRef;
  minDate = new Date(1900, 1, 1);

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private slugify: SlugifyPipe,
    private toastyService: ToastyService,
    private service: AssociationService,
    private modalService: BsModalService,
    private bsLocaleService: BsLocaleService,
    private countryService: CountryService,
    private ngbmodalService: NgbModal
  ) {
    // defineLocale(frLocale.abbr, frLocale);
    // this.bsLocaleService.use('fr');

    this.association = this.route.snapshot.data["association"];
    this.categories = this.route.snapshot.data["categories"];
    this.assocTypes = this.route.snapshot.data["association_types"];
    this.odds = this.route.snapshot.data["odds"];
    this.regions = this.route.snapshot.data["regions"];

    this.assocTypes.forEach((type: AssocType) => {
      if ("PRIVATE" === type.assoc_type) {
        this.assocTypesPrivate.push(type);
      }
    });

    // tslint:disable-next-line:max-line-length
    const patternEmail =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const patternWebSite =
      /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/;
    const patternAssocCode = /^[a-zA-Z0-9]*$/;

    this.associationDetailsForm = this.formBuilder.group({
      website: ["", [Validators.required, Validators.pattern(patternWebSite)]],
      name: ["", [Validators.required, Validators.minLength(3)]],
      description: ["", Validators.required],
      assoc_category_id: ["", Validators.required],
      country_iso: ["FR", Validators.required],
      recognized_at: ["", Validators.required],
      published_at: ["", Validators.required],
      address_line_1: ["", Validators.required],
      address_line_2: ["", Validators.required],
      dedicated_part: [
        "",
        [Validators.required, Validators.min(0), Validators.max(100)],
      ],
      state: [""],
      city: ["", Validators.required],
      post_code: ["", Validators.required],
      rep_firstname: ["", [Validators.required, Validators.minLength(3)]],
      rep_name: ["", [Validators.required, Validators.minLength(3)]],
      rep_email: ["", [Validators.required, Validators.pattern(patternEmail)]],
      email: ["", [Validators.required, Validators.pattern(patternEmail)]],
      rep_birth_date: ["", Validators.required],
      rep_nationality_iso: ["Française", Validators.required],
      rep_address_line_1: [""],
      rep_address_line_2: [""],
      rep_country_iso: ["FR", Validators.required],
      rep_state: [""],
      rep_city: [""],
      rep_post_code: [""],
      title: ["", [Validators.minLength(3)]],
      assoc_object: ["", Validators.required],
      cerfa_type: ["", Validators.required],
      certification: ["", Validators.required],
      assoc_type: ["", Validators.required],
      assoc_code: [
        "",
        [
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(4),
          Validators.pattern(patternAssocCode),
        ],
      ],
      assoc_status: ["", Validators.required],
      // 'reduc_fisc_pal_1': ['', [Validators.required, Validators.min(0), Validators.max(100)]],
      // 'reduc_fisc_pal_2': ['', [Validators.required, Validators.min(0), Validators.max(100)]]
      equivalence_100euro: [""],
      equivalence_30euro: [""],
      odds: [[]],
      countries: [[]],
      regions: [[]],
      assoc_categories: [[]],
      siren: ["", Validators.required],
      cerfa_enterprise_case: [1, Validators.required],
      cerfa_individual_case: [1, Validators.required],
      cerfa_article: [[]],
      cerfa_free_field: [""],
    });

    this.countryService.getCountries().subscribe((data) => {
      this.countries = data;
      this.countries.forEach((country) => {
        if (
          country.nationality.fr &&
          !this.nationalities.includes(country.nationality.fr)
        ) {
          this.nationalities.push(country.nationality.fr);
        }
      });

      this.countries = this.move(
        this.countries,
        this.countries.indexOf(
          this.countries.filter((country) => country.alpha2Code === "FR")[0]
        ),
        0
      );
      this.nationalities = this.move(
        this.nationalities,
        this.nationalities.indexOf("Française"),
        0
      );
    });

    this.associationDetailsForm.valueChanges.subscribe(console.log);
  }

  ngOnInit() {
    const initial = Object.assign(
      {},
      {
        website: this.association.website,
        name: this.association.name,
        address_line_1: this.association.assoc_address
          ? this.association.assoc_address.address_line_1
          : "",
        address_line_2: this.association.assoc_address
          ? this.association.assoc_address.address_line_2
          : "",
        assoc_category_id: this.association.category.id,
        assoc_object: this.association.assoc_object,
        assoc_status: this.association.assoc_status,
        assoc_type:
          this.association.assoc_types.length > 0
            ? this.association.assoc_types.filter(
                (type) => "PRIVATE" === type.assoc_type
              )[0].id
            : this.assocTypesPrivate[0].id,
        cerfa_type: this.association.cerfa_type,
        certification: this.association.certification,
        city: this.association.assoc_address
          ? this.association.assoc_address.city
          : "",
        country_iso: this.association.assoc_address
          ? this.association.assoc_address.country_iso
          : "",
        dedicated_part: this.association.dedicated_part,
        description: this.association.description,
        email: this.association.email,
        post_code: this.association.assoc_address
          ? this.association.assoc_address.post_code
          : "",
        published_at: this.association.published_at,
        recognized_at: this.association.recognized_at,
        state: this.association.assoc_address
          ? this.association.assoc_address.state
          : "",
        rep_firstname: this.association.assoc_rep
          ? this.association.assoc_rep["firstname"]
          : "",
        rep_name: this.association.assoc_rep
          ? this.association.assoc_rep["name"]
          : "",
        rep_email: this.association.assoc_rep
          ? this.association.assoc_rep["email"]
          : "",
        rep_birth_date: this.association.assoc_rep
          ? this.association.assoc_rep["birth_date"]
          : "",
        rep_nationality_iso: this.association.assoc_rep
          ? this.association.assoc_rep["nationality_iso"]
          : "",
        rep_address_line_1: this.association.assoc_rep
          ? this.association.assoc_rep["assoc_rep_address"]
            ? this.association.assoc_rep["assoc_rep_address"]["address_line_1"]
            : ""
          : "",
        rep_address_line_2: this.association.assoc_rep
          ? this.association.assoc_rep["assoc_rep_address"]
            ? this.association.assoc_rep["assoc_rep_address"]["address_line_2"]
            : ""
          : "",
        // tslint:disable-next-line:max-line-length
        rep_country_iso: this.association.assoc_rep
          ? this.association.assoc_rep["assoc_rep_address"]
            ? this.association.assoc_rep["assoc_rep_address"]["country_iso"]
            : ""
          : "",
        rep_state: this.association.assoc_rep
          ? this.association.assoc_rep["assoc_rep_address"]
            ? this.association.assoc_rep["assoc_rep_address"]["state"]
            : ""
          : "",
        rep_city: this.association.assoc_rep
          ? this.association.assoc_rep["assoc_rep_address"]
            ? this.association.assoc_rep["assoc_rep_address"]["city"]
            : ""
          : "",
        rep_post_code: this.association.assoc_rep
          ? this.association.assoc_rep["assoc_rep_address"]
            ? this.association.assoc_rep["assoc_rep_address"]["post_code"]
            : ""
          : "",
        title: this.association.title,
        assoc_code: this.association.assoc_code,
        // reduc_fisc_pal_1: this.association.reduc_fisc_pal_1,
        // reduc_fisc_pal_2: this.association.reduc_fisc_pal_2
        equivalence_100euro: this.association.equivalence_100euro,
        equivalence_30euro: this.association.equivalence_30euro,
        odds: this.association.odds,
        countries: this.association.countries,
        regions: this.association.regions,
        assoc_categories: this.association.assoc_categories,
        siren: this.association.siren,
        cerfa_enterprise_case: this.association.assoc_cerfa_field
          ? this.association.assoc_cerfa_field.enterprise_case.toString()
          : "",
        cerfa_individual_case: this.association.assoc_cerfa_field
          ? this.association.assoc_cerfa_field.individual_case.toString()
          : "",
        cerfa_article: this.association.assoc_cerfa_field
          ? this.association.assoc_cerfa_field.article
          : [],
        cerfa_free_field: this.association.assoc_cerfa_field
          ? this.association.assoc_cerfa_field.free_field
          : "",
      }
    );
    this.associationDetailsForm.patchValue(initial);
  }

  onAssociationDetailsEditCancel(): void {
    this.router.navigate(["/associations/list"]);
  }

  onSave(template: TemplateRef<any>) {
    this.validateAllFormFields(this.associationDetailsForm);

    if (this.associationDetailsForm.valid) {
      this.confirmModalRef = this.modalService.show(template, {
        class: "modal-sm",
      });
    } else {
      this.toastyService.error({
        title: "Attention",
        msg: "Veuillez corriger les erreurs",
        showClose: true,
        timeout: 5000,
        theme: "bootstrap",
      });
    }
  }

  onCancel() {
    this.confirmModalRef.hide();
  }

  onAssociationDetailsEditSubmit(): void {
    (<any>Object).assign(this.association, {
      website: this.associationDetailsForm.value["website"],
      name: this.associationDetailsForm.value["name"],
      url: this.slugify.transform(this.associationDetailsForm.value["name"]),
      email: this.associationDetailsForm.value["email"],
      dedicated_part: this.associationDetailsForm.value["dedicated_part"],
      description: this.associationDetailsForm.value["description"],
      assoc_category_id: this.associationDetailsForm.value["assoc_category_id"],
      cerfa_type: this.associationDetailsForm.value["cerfa_type"],
      certification: this.associationDetailsForm.value["certification"],
      assoc_type: this.associationDetailsForm.value["assoc_type"],
      title: this.associationDetailsForm.value["title"],
      assoc_object: this.associationDetailsForm.value["assoc_object"],
      assoc_status: this.associationDetailsForm.value["assoc_status"],
      reduc_fisc_pal_1: this.associationDetailsForm.value["reduc_fisc_pal_1"],
      reduc_fisc_pal_2: this.associationDetailsForm.value["reduc_fisc_pal_2"],
      recognized_at: moment(
        this.associationDetailsForm.value["recognized_at"]
      ).set("hour", 10),
      published_at: moment(
        this.associationDetailsForm.value["published_at"]
      ).set("hour", 10),
      assoc_code: this.associationDetailsForm.value["assoc_code"],
      equivalence_100euro:
        this.associationDetailsForm.value["equivalence_100euro"],
      equivalence_30euro:
        this.associationDetailsForm.value["equivalence_30euro"],
      odds: this.associationDetailsForm.value["odds"],
      countries: this.associationDetailsForm.value["countries"],
      regions: this.associationDetailsForm.value["regions"],
      assoc_categories: this.associationDetailsForm.value["assoc_categories"],
      siren: this.associationDetailsForm.value["siren"],
      assoc_cerfa_field: {
        enterprise_case: this.associationDetailsForm.value["cerfa_enterprise_case"],
        individual_case: this.associationDetailsForm.value["cerfa_individual_case"],
        article: this.associationDetailsForm.value["cerfa_article"],
        free_field: this.associationDetailsForm.value["cerfa_free_field"],
      },
    });

    const assocAdress = new Address();
    (<any>Object).assign(assocAdress, {
      country_iso: this.associationDetailsForm.value["country_iso"],
      address_line_1: this.associationDetailsForm.value["address_line_1"],
      address_line_2: this.associationDetailsForm.value["address_line_2"],
      state: this.associationDetailsForm.value["state"],
      city: this.associationDetailsForm.value["city"],
      post_code: this.associationDetailsForm.value["post_code"],
    });
    this.association.assoc_address = assocAdress;

    this.association.assoc_rep = Object.assign(
      {},
      {
        firstname: this.associationDetailsForm.value["rep_firstname"],
        name: this.associationDetailsForm.value["rep_name"],
        email: this.associationDetailsForm.value["rep_email"],
        birth_date: moment(this.associationDetailsForm.value["rep_birth_date"])
          .set("hour", 10)
          .format(),
        nationality_iso:
          this.associationDetailsForm.value["rep_nationality_iso"],
        assoc_rep_address: Object.assign(
          {},
          {
            country_iso: this.associationDetailsForm.value["rep_country_iso"],
            address_line_1:
              this.associationDetailsForm.value["rep_address_line_1"],
            address_line_2:
              this.associationDetailsForm.value["rep_address_line_2"],
            city: this.associationDetailsForm.value["rep_city"],
            state: this.associationDetailsForm.value["rep_state"],
            post_code: this.associationDetailsForm.value["rep_post_code"],
          }
        ),
      }
    );
    delete this.association.category;

    const all = [];
    if (this.logo) {
      const formData: FormData = new FormData();
      formData.append("assoc[logo]", this.logo, this.logo.name);
      all.push(this.service.upload(this.association.id, formData, ""));
    }

    if (this.banner) {
      const formData: FormData = new FormData();
      formData.append("assoc[banner]", this.banner, this.banner.name);
      all.push(this.service.upload(this.association.id, formData, ""));
    }

    if (this.description) {
      const formData: FormData = new FormData();
      formData.append(
        "assoc[desc_doc]",
        this.description,
        this.description.name
      );
      all.push(this.service.upload(this.association.id, formData, ""));
    }

    if (this.event) {
      const formData: FormData = new FormData();
      formData.append("assoc[event_doc]", this.event, this.event.name);
      all.push(this.service.upload(this.association.id, formData, ""));
    }

    if (this.signature) {
      const formData: FormData = new FormData();
      formData.append("assoc[signature]", this.signature, this.signature.name);
      all.push(this.service.upload(this.association.id, formData, ""));
    }

    all.push(this.service.update(this.association));
    observableForkJoin(all).subscribe(
      (data) => {
        this.router.navigate(["/associations/list"]);
      },
      (err) => {
        console.log(err);
        this.toastyService.error({
          title: "Attention",
          msg:
            "Une erreur s'est produite\n <br />" + err.error.errors[0].details,
          showClose: true,
          timeout: 10000,
          theme: "bootstrap",
        });
      }
    );

    this.confirmModalRef.hide();
  }

  onSignatureChange(input) {
    if (input.target.files && input.target.files.length > 0) {
      const reader = new FileReader();
      reader.readAsDataURL(input.target.files[0]);
      reader.onload = (event: any) => {
        const modalRef = this.ngbmodalService.open(ImageCropperComponent);
        modalRef.componentInstance.img64 = event.target.result;

        modalRef.result.then(
          (result) => {
            if ("modal-cancel" !== result) {
              console.log("result", result);

              const block = result.split(";");
              const contentType = block[0].split(":")[1];
              const realData = block[1].split(",")[1];
              console.log("contentType", contentType);
              const blob = this.b64toBlob(realData, contentType, 512);
              this.signature = new File(
                [blob],
                input.target.files[0].name.substring(
                  0,
                  input.target.files[0].name.indexOf(".")
                ) + ".jpg",
                { type: contentType }
              );
            }
          },
          (error) =>
            this.toastyService.error({
              title: "Attention",
              msg: "Une erreur s'est produite",
              showClose: true,
              timeout: 5000,
              theme: "bootstrap",
            })
        );
      };
    }
  }

  private validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((field) => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  private move(array: any[], from: number, to: number) {
    array.splice(to, 0, array.splice(from, 1)[0]);
    return array;
  }

  /** Convert a base64 string in a Blob according to the data and contentType.
   *
   * @param b64Data {String} Pure base64 string without contentType
   * @param contentType {String} the content type of the file i.e (image/jpeg - image/png - text/plain)
   * @param sliceSize {Int} SliceSize to process the byteCharacters
   * @see http://stackoverflow.com/questions/16245767/creating-a-blob-from-a-base64-string-in-javascript
   * @return Blob
   */
  private b64toBlob(b64Data, contentType, sliceSize): Blob {
    contentType = contentType || "";
    sliceSize = sliceSize || 512;

    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: contentType });
  }
}
